import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
const Option = Select.Option

@Form.create()
class UpdateSalaryStatus extends React.Component {
    state = {
        visible: true,
        loading: false,
        allUsers: [],
        statusApprove: null
    }

    componentDidMount() {
        const { users } = this.props;
        this.setState({ allUsers: users })
    }

    handleSubmit = (e) => {
        let { form, dispatch, recordId } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.id = this.props.recordId;
            let response = await Request.updateStaffSalaryStatus(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
                this.onClose()
            } else {
                notification.error({
                    message: response.message
                })
                this.onClose()
            }
        })
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    render() {
        let { statusApprove } = this.state
        const inputTypes = {
            fields: [
                {
                    label: 'Status',
                    key: 'confirmationStatus',
                    type: 'select',
                    options: ['Approved', 'Disapproved'],
                    required: true,
                    onChange: (v) => {
                        this.props.form.setFieldsValue({
                            confirmationStatus: v
                        });
                        this.setState({ statusApprove: v === 'Approved' });
                    }
                },
                {
                    label: 'Any Comment',
                    key: 'comment',
                    type: 'textarea',
                    hidden: !statusApprove,
                    required: false // optional when shown
                },
                {
                    label: 'Reason',
                    key: 'disapproveReason',
                    type: 'textarea',
                    hidden: statusApprove,
                    required: !statusApprove // required when shown
                }
            ]
        };

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { visible } = this.state
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Salary Update
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateSalaryStatus)
